import { Icon, type IconName } from '#app/components/ui/icon.tsx'

/**
 * The shared `bg-brand-soft` brand icon tile (48×48 with a 20px glyph) used
 * across the marketing capability surfaces — the `/features` groups
 * ({@link ../__feature-groups.tsx}) and the home teaser
 * ({@link ../__feature-teaser.tsx}). One source so the tile stays identical
 * wherever a capability is introduced.
 */
export function IconTile({ name }: { name: IconName }) {
	return (
		<span className="bg-brand-soft text-brand grid h-12 w-12 place-items-center rounded-lg">
			<Icon name={name} className="h-5 w-5" aria-hidden />
		</span>
	)
}
